module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAALCAYAAAB7/H1+AAAAbklEQVQ4T7XQSw6AIBAD0Kk38n7CQrge8UZgomAiDsP4674vTUE/BVp3NGkaQAgznKajgjNaQKvBu3CF7mMj2eDl5SLMovmHmMgsDr51SxOW0IJJOAtr0B5+ge+gEn6Cn6At/IDfoBy+wV+gNb4C2cBADKTMni0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/index-d_icon_sign.png
// module id = kohN
// module chunks = 1